<template>
  <Section class="intro" type="yellow">
    <Heading class="intro__heading">Leaving Discord for Slack?</Heading>
    <Description class="intro__description">
      We can help you export all of your Discord messages along with your karma records (<code>@user ++</code>) if you are migrating from Slack.
      <br><br>
      <strong>Here is the plan:</strong>
    </Description>
  </Section>
</template>

<script>
  import Section from './UI/Section'
  import Heading from './UI/Heading'
  import Description from './UI/Description'

  export default {
    components: {
      Section,
      Heading,
      Description
    }
  }
</script>

<style lang="scss" scoped>
  .intro__description {
    max-width: 550px;
  }
</style>
